export default {
  priv: 'pr_reference',
  overviewTitle: 'Projectleiders',
  detailTitle: 'Projectleider',
  deleteTitle: 'deze projectleider',
  url: '/references/projectmanagers',
  apiUrl: '/projectmanagers/',
  sortBy: ['name'],
  sortDesc: [false],
  deletable: true,
  editable: true,
  filterName: 'projectmanagers',
  quickFilter: {
    text: 'Zoek op naam',
    value: 'name',
    type: 'text'
  },
  tableFields: [
    {
      text: 'Naam',
      value: 'name',
      link: '/references/projectmanagers/{id}',
      width: '80%'
    }
  ]
};
